import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardBunnyRebrand(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_250_509)">
        <path
          d="M60 119.586C86.1104 119.586 100.626 119.586 110.106 110.106C119.586 100.626 119.586 86.1104 119.586 60C119.586 33.8897 119.586 19.3738 110.106 9.89382C100.626 0.413818 86.1104 0.413818 60 0.413818C33.8897 0.413818 19.3738 0.413818 9.89382 9.89382C0.413818 19.3738 0.413818 33.8897 0.413818 60C0.413818 86.1104 0.413818 100.626 9.89382 110.106C19.3738 119.586 33.8897 119.586 60 119.586Z"
          fill="#FAFA64"
        />
        <path
          d="M63.5711 60.2463C66.2173 50.549 70.8104 35.0711 60.5194 35.0711C57.1304 35.0711 54.7945 37.2269 54.7945 42.2463C54.7945 50.6814 54.8131 71.6235 54.8131 76.7173C54.8131 79.3407 55.3345 84.4511 60.5194 84.4511C64.2538 84.4511 66.6766 82.3304 66.6766 76.7173V70.8414H78.9125C78.9125 77.9152 79.409 96.5566 60.5194 96.5566C55.6821 96.5566 41.0835 94.6676 41.0835 74.7911L41.0959 44.5718C41.0959 26.7456 52.7483 23.4476 60.5194 23.4476C76.2456 23.4476 83.5676 36.1594 75.7738 60.2483H63.5711V60.2463Z"
          fill="#33191B"
        />
      </g>
      <defs>
        <clipPath id="clip0_250_509">
          <rect width="120" height="120" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClipboardBunnyRebrand);
export default ForwardRef;
